import { VIEW_TYPE_CONFIG } from '../../constants';
import { usePhanHeBaoHiemYTeContext } from '../../contexts';
import CheckInPreview from '../check-in-preview';
import Action from './Action';
import PaymentInfo from './PaymentInfo';
import PrimaryInfo from './PrimaryInfo';
import ServiceInfo from './ServiceInfo';

const PatientInfo = () => {
	const { viewType } = usePhanHeBaoHiemYTeContext();

	const isViewPatientCheckIn = viewType === VIEW_TYPE_CONFIG.PATIENT_CHECK_IN;

	if (isViewPatientCheckIn) return <CheckInPreview />;

	return (
		<div className="bg-white d-flex flex-column h-100">
			<div className="flex-column-auto">
				<PrimaryInfo />
			</div>

			<div className="flex-column-fluid overflow-auto spaces h-calc-vh-200">
				<ServiceInfo />
				<PaymentInfo />
			</div>

			<div className="flex-column-auto spaces pt-2 min-h-56 shadow-sm">
				<Action />
			</div>
		</div>
	);
};

export default PatientInfo;
